/**
 * Filters
 *
 * Class that handles the filters
 */
import loadingSVG from '@images/loading.svg';
import loadingWhiteSVG from '@images/loading-white.svg';

/* eslint-disable */
class Filters {
    constructor() {
        this.taxonomyPrograms = 'programs';
        this.taxonomyInstitutionTypes = 'institution_types';
        this.taxonomyLevelsOfStudy = 'levels_of_study';
        this.taxonomyLearningFormats = 'learning_formats';
        this.taxonomyProgramLengths = 'program_lengths';
        this.taxonomyOnCampusLiving = 'on_campus_living';
        this.searchTermFieldName = 'search_term';
        this.programAreaFieldName = 'program_area';
        this.programsSelectClass = 'programs';
        this.programAreaSelectClass = 'program-area';
        this.filterElementsClass = 'filter-elements'; // class assigned to form elements that will change
        this.filterFormClass = 'filter-form';
        this.resultsListItemClass = 'results__list__item';
        this.resultsListClass = 'results__list--institutions';
        this.disabledLabelClass = 'checkbox-group__label--disabled';
        // this.translatedStrings = translatedStrings.Filters;
        this.wpEmerge = wpEmerge;
        this.wpQuery = wpQuery;
        this.loadingScreenClass = 'loading-screen';
        this.filterLoadingClass = 'filters--institutions__wrapper:visible';
        this.resultsLoadingClass = 'results';
        this.filtersActivityListClass = 'filters-activity__list';
        this.filterHeadingClass = 'filters--institutions__heading';
    }

    /**
     * The initialization function of the
     * filters.
     */
    init() {
        // Updates the programs area dropdown based on programs selection
        this.onProgramsChange();

        // Gets the new posts on filter change
        this.onFilterChange();

        // Gets the new posts on form submit
        this.onFilterSubmit();
    }

    /**
     * On Filter Change
     *
     * Getting the current form data state
     * after every single select or checkbox
     * change. That data will be passed to the
     * AJAX request to return the institutions.
     */
    onFilterChange(self = this) {
        const filterForm = $(`form.${self.filterFormClass}`);
        const filterElements = filterForm.find(`.${self.filterElementsClass}`);
        const filterSearch = filterForm.find(`[name=${self.searchTermFieldName}]`);
        let typingTimer;
        let typingDelay = 700;

        // Search field input
        filterSearch.on('input', (event) => {
            // Clear timeout while typing
            clearTimeout(typingTimer);

            // Initialize the timeout
            typingTimer = setTimeout(() => {
                const filterElement = $(event.target);
                const filterForm = filterElement.parents('form');

                // Only on visible forms
                if (filterForm.is(':visible')) {
                    // Sync forms and update results
                    self.onChangeLogic(filterElement, self);
                }
            }, typingDelay);
        })

        // Dropdown and checkbox/radio changes
        filterElements.on('change', (event) => {
            const filterElement = $(event.target);
            const filterForm = filterElement.parents('form');

            // Only on visible forms
            if (filterForm.is(':visible')) {
                // Sync forms and update results
                self.onChangeLogic(filterElement, self);
            }
        });
    }

    /**
     * Update Filter Status
     *
     *
     * @param {obj} self The Filters class object
     */
    updateFilterStatus(filterElement, self = this) {
        const fieldName = filterElement.attr('name');
        const fieldNameStripped = fieldName.replace(/[\[\]']+/g, '');
        const fieldValue = filterElement.val();
        const fieldTag = filterElement.prop("tagName").toLowerCase();
        const filterForm = filterElement.parents('form');
        const filterElementSelect = (fieldTag == 'select')? filterForm.find(`[name=${fieldName}] option:selected`) : false;
        const filterElementChecked = (fieldTag == 'input') ? filterElement.is(':checked') : false;
        let fieldLabel = filterElement.parent('label').text();
        fieldLabel = (!fieldLabel) ? filterForm.find($(`select[name='${fieldName}']>option[value='${fieldValue}']`)).text() : fieldLabel;
        const filterStatusButton = $(`<span class="button--pill d-flex align-items-center justify-content-center button--pill--${fieldValue} button--pill--${fieldNameStripped
            }" data-filter="${fieldName}" data-value="${fieldValue}">${fieldLabel}</span>`);
        const filterListItem = $(`<li class="col-auto filters-activity__list__item"></li>`);

        if ((filterElementChecked || filterElementSelect) && fieldValue) {
            if (fieldNameStripped == 'program') {
                $(`.button--pill--${fieldNameStripped}`).parent('li').remove();
                $(`.button--pill--${self.programAreaFieldName}`).parent('li').remove();
            }
            filterListItem.append(filterStatusButton);

            filterListItem.appendTo(`.${self.filtersActivityListClass}`);

            $('.col-clear-filter').css('display', 'flex');
        } else {
            // If dropdown `select` is chosen
            if ((fieldNameStripped == 'program' || fieldNameStripped == 'program_area') && !fieldValue) {
                $(`.button--pill--${fieldNameStripped}`).parent('li').remove();
                $(`.button--pill--${self.programAreaFieldName}`).parent('li').remove();
            } else {
                $(`.button--pill--${fieldValue}`).parent('li').remove();
            }

            // Check if that was the last list item, then hide the filter clear button
            setTimeout(() => {
                const listItems = $('.filters-activity__list__item');

                if (listItems.length == 0) {
                    $('.col-clear-filter').css('display', 'none');
                }
            }, 20)
        }
    }

    /**
     *
     * Suppose to cancel the filter if you click on the bubble,
     * but this was left out for the time.
     *
     * @param {*} thisButton
     * @param {*} self
     */
    onFilterStatusButtonClick(thisButton, self = this) {
        const buttonListItem = thisButton.parent('li');
        const fieldName = thisButton.data('filter');
        const fieldValue = thisButton.data('value');
        const filterForm = $(`form.${self.filterFormClass}`);
        const filterElement = filterForm.find(`[name="${fieldName}"]`);
        const fieldTag = filterElement.prop("tagName").toLowerCase();
        const fieldType = filterElement.attr('type');
        const filterElementSelect = (fieldTag == 'select') ? filterForm.find(`[name=${fieldName}] option:selected`) : false;
        const filterElementChecked = (fieldTag == 'input') ? filterElement.is(':checked') : false;

        // Type of element
        switch (fieldTag) {
            case 'input':
                // Type of form input
                switch (fieldType) {
                    case 'checkbox':
                    case 'radio':
                        if (filterElementChecked) {
                            filterForm.find(`input[name='${fieldName}'][value=${fieldValue}]`).trigger('click');
                        }

                        // Remove the list item
                        buttonListItem.remove();

                        break;

                    case 'text':
                        filterForm.find(`input[name='${fieldName}']`).val('');
                        // Remove the list item
                        buttonListItem.remove();
                        break;
                }
                break;
            case 'select':
                if (filterElementSelect) {
                    filterForm.find(`select[name='${fieldName}']`).val('').change();
                }

                // Remove the list item
                buttonListItem.remove();

                break;
        }

        // Check if that was the last list item, then hide the filter clear button
        setTimeout(() => {
            const listItems = $('.filters-activity__list__item');

            if (listItems.length == 0) {
                $('.col-clear-filter').css('display', 'none');
            }
        }, 20)
    }

    /**
     * On Filter Submit
     *
     * On form submit, either clicking on the search
     * button or by hitting enter. It will prevent the
     * form from being submitted and instead do the same
     * AJAX logic.
     *
     * @param {obj} self The Filters class object
     */
    onFilterSubmit(self = this) {
        const filterForm = $(`form.${self.filterFormClass}`);

        filterForm.on('submit', (event) => {
            event.preventDefault();

            if ($(event).is(':visible')) {
                self.requestFilteredPosts(self);
            }
        })
    }

    /**
     * On Change Logic
     *
     * The general logic that will be applied
     * when a filter change action is taken.
     *
     * @param {obj} filterElement The filter element that is being
                                  interacted with.
     * @param {obj} self          The Filters class object
     */
    onChangeLogic(filterElement, self = this) {
        // Add selected filter to the status bar
        self.updateFilterStatus(filterElement, self);

        // Make AJAX call and fire callback function on success. If error occurs, fire error callback function.
        self.requestFilteredPosts(self);

        // Sync the mobile and desktop forms on change
        self.syncMobileDesktopFormFilters(filterElement, self);
    }

    /**
     * Sync Mobile Desktop Form Filters
     *
     * Because there are two duplicate filter forms,
     * one for mobile and one for desktop, we need to
     * make sure the form user actions are synced. When
     * user happens to switch between mobile and desktop
     * views the filter form is always the same.
     *
     * @param {obj} filterElement The filter element that is being
                                  interacted with.
     * @param {obj} self          The Filters class object
     */
    syncMobileDesktopFormFilters(filterElement, self = this) {
        const fieldTag = filterElement.prop("tagName").toLowerCase();
        const fieldType = filterElement.attr('type');
        const fieldName = filterElement.attr('name');
        const fieldValue = (filterElement.val()) ? filterElement.val() : '';
        const filterForm = $(`form.${self.filterFormClass}:hidden`);

        // Type of element
        switch (fieldTag) {
            case 'input':
                // Type of form input
                switch (fieldType) {
                    case 'checkbox':
                    case 'radio':
                        // Find the input with the same name and value and trigger a click even to check it on or off
                        filterForm.find(`input[name='${fieldName}'][value=${fieldValue}]`).trigger('click');
                        break;

                    case 'text':
                        filterForm.find(`input[name='${fieldName}']`).val(fieldValue);
                        break;
                }
                break;
            case 'select':
                filterForm.find(`select[name='${fieldName}']>option[value='${fieldValue}']`).attr('selected', true);
                break;
        }
    }

    /**
     * Request Filtered Posts
     *
     * The logic that is used to get the
     * results with the applied filters.
     *
     * @param {obj} self The Filters class object
     */
    requestFilteredPosts(self = this) {
        const form = $(`form.${self.filterFormClass}:visible`);
        const formDataArray = form.serializeArray();
        const preparedFormData = self.prepareFormData(formDataArray);

        self.getFilteredPosts(
            preparedFormData,
            (results) => {
                const resultsList = $(`.${self.resultsListClass}`);
                const institutions = (results.institutions) ? results.institutions : null;
                const resultsStatus = (results.resultsStatus) ? results.resultsStatus : null;

                // Let assistive technology users that the list is in the process of being updated
                wp.a11y.speak(i18n.Filters.updatingResults);

                // Clear the current list
                resultsList.children().remove();

                // Populate the list with returned cards inside of list items
                if (institutions && institutions.length > 0) {
                    self.updateResultsList(results, self);

                    self.updateResultsStatus(resultsStatus, self);

                    // Announce to assistive technology users that the list has been updated
                    wp.a11y.speak(i18n.Filters.resultsUpdated);
                } else {
                    const listItem = $('<li></li>').attr('class', `${self.resultsListItemClass}--no-results`).text(i18n.Filters.noResultsFound);

                    // Append the list item to the list
                    resultsList.append(listItem);

                    // Annouce to ATUs that there were no results
                    wp.a11y.speak(i18n.Filters.noResultsFound);
                }
            },
            () => {
                // Let assistive technology users know that the results couldn't be updated (due to a technical error)
                wp.a11y.speak(i18n.Filters.error);
            },
            self
        );
    }

    /**
     * Update Result's Status
     *
     * Updates the `x - x results` text
     *
     * @param {array} resultsStatus
     */
    updateResultsStatus(resultsStatus) {
        const pageStart = (resultsStatus.pageStartCount) ? resultsStatus.pageStartCount : null;
        const queryTotal = (resultsStatus.totalQueryCount) ? resultsStatus.totalQueryCount : null;

        $('.filters-activity__heading__page-start').text(pageStart);
        $('.filters-activity__heading__query-total').text(queryTotal);
    }

    /**
     * Update Results List
     *
     * Using the results data that we get back from
     * the AJAX request and updating the list. There is
     * a card template that we get back that we're using
     * to input the result data into and append to the list.
     *
     * @param {array} results The array of results and their data
     * @param {obj}   self    The Filters class object
     */
    updateResultsList(results, self = this) {
        const resultsList = $(`.${self.resultsListClass}`);
        const institutions = (results.institutions) ? results.institutions : null;

        if (institutions && institutions.length > 0){
            institutions.forEach(card => {
                if (card) {
                    const cardImage = card.image;
                    const cardLocality = card.locality;
                    const cardLogo = card.logo;
                    const cardProvince = card.province;
                    const cardSlug = card.slug;
                    const cardTitle = card.title;
                    const cardUrl = card.url;
                    const cardTemplate = $(results.cardTemplate);
                    const listItem = $('<li></li>').attr('class', self.resultsListItemClass);

                    // Updating the card id and aria label
                    cardTemplate
                        .attr('id', cardSlug)
                        .attr('aria-labelledby', `${cardSlug}__heading`);

                    // Updating the card heading
                    cardTemplate
                        .find('.card__heading')
                        .attr('id', `${cardSlug}__heading`);

                    // Updating the anchor link values
                    cardTemplate
                        .find('.card__anchor')
                        .attr('href', cardUrl)
                        .text(cardTitle);

                    // Updating the logo values
                    cardTemplate
                        .find('.card--institution__logo')
                        .attr('src', cardLogo.url)
                        .attr('alt', cardLogo.alt)
                        .attr('sizes', cardLogo.sizes)
                        .attr('width', cardLogo.width)
                        .attr('height', cardLogo.height);

                    // Updating the featured image values
                    cardTemplate.find('.card--institution__featured__image')
                        .attr('src', cardImage.src)
                        .attr('srcset', cardImage.srcset)
                        .attr('alt', cardImage.alt)
                        .attr('sizes', cardImage.sizes)
                        .attr('width', cardImage.width)
                        .attr('height', cardImage.height);

                    // Adding the province value... and favourite data?
                    if (cardLocality && cardProvince) {
                        cardTemplate.find('.js-favourite-button-placeholder')
                            .attr('data-favourite-id', cardSlug)
                            .attr('data-favourite-location', `${cardLocality}, ${cardProvince}`)
                            .attr('data-favourite-title', cardTitle)
                            .attr('data-favourite-url', cardUrl)
                        cardTemplate
                            .find('dd')
                            .text(cardProvince);
                    }

                    // Append the card template to the list item
                    listItem.append(cardTemplate);

                    // Append the list item to the list
                    resultsList.append(listItem);
                }
            });
        }
    }

    /**
     * Prepare Field Data
     *
     * This is done so that filters with multiple options
     * are gathered under one array value.
     *
     * @param {obj} self The Filters class object
     */
    prepareFieldData(self = this) {
        const filters = [self.taxonomyInstitutionTypes, self.taxonomyLevelsOfStudy, self.taxonomyLearningFormats, self.taxonomyProgramLengths];

        filters.forEach(filter => {
            const fields = $(`[name=${filter}_selection]:checked`);
            const hiddenField = $(`[name=${filter}]`);
            const selectedValues = [];

            fields.each(index => {
                const field = $(fields[index]);
                const fieldValue = field.val();

                if (fieldValue) {
                    selectedValues.push(fieldValue);
                }

                field.prop("disabled", true);
            })

            hiddenField.val(selectedValues.join(','));
        })
    }

    /**
     * Resets Filters
     *
     * Clicking on the button will redirect
     * the user to the archive page without any
     * active filters.
     */
    resetFilters() {
        $('[name=reset_filters]').on('click', (e) => {
            e.preventDefault();
            location.href = e.target.dataset.redirect;
        })
    }

    /**
     * Disable Unselected Fields
     *
     * Disabling unselected fields on form submit
     * to exclude the empty filter params from the URL.
     *
     * @param {obj} self The Filters object
     */
    disableUnsellectedFields(self = this) {
        const filters = [self.searchTermFieldName, self.taxonomyPrograms, self.taxonomyInstitutionTypes, self.taxonomyLevelsOfStudy, self.taxonomyLearningFormats, self.taxonomyProgramLengths];

        filters.forEach(filter => {
            const fields = $(`[name=${filter}]`);

            fields.each(index => {
                const field = $(fields[index]);
                const fieldValue = field.val();

                if (!fieldValue) {
                    field.prop("disabled", true);
                }
            })
        })
    }

    /**
     * Disable Inactive Filters
     *
     * After every filter change we get back new
     * results and also the active taxonomy terms
     * based on the current filter query. The active
     * terms are then used to disable the inactive
     * filter options so that we're always getting results.
     *
     * @param {string} filterType  The name of the filter, also used as selector
     * @param {array}  activeTerms The array of active term ids
     * @param {obj}    self        The Filter class object
     */
    disableInactiveFilters(filterType, activeTerms, self = this) {
        const filterTypeName = `${filterType}[]`;
        const filterOptions = (filterTypeName == 'programs_options') ? $(`.${filterType}`) : $(`[name='${filterTypeName}']`);

        // Activate all filter options and remove the disable class state from labels
        filterOptions.prop("disabled", false).parents('label').removeClass(self.disabledLabelClass);

        // Check if there are active terms available
        if (filterOptions.length > 0) {
            // Loop through each filter option
            filterOptions.each(index => {
                const filterOption = $(filterOptions[index]);
                const filterOptionValue = filterOption.val();

                // Disable filter options that are not part of the active terms
                if (!activeTerms.includes(filterOptionValue)) {
                    filterOption.prop("disabled", true).parents('label').addClass(self.disabledLabelClass);
                }
            })
        }
    }

    /**
     * Get Filtered Posts
     *
     * An AJAX call is made when the filters
     * are changed to get back the posts based
     * on the new query.
     *
     * @param {obj}      preparedFormData The prepared form data
     * @param {callback} onSuccess        The success callback function
     * @param {callback} onError          The error callback function
     * @param {obj}      self             The Filter class object
     */
    getFilteredPosts(preparedFormData, onSuccess, onError, self = this) {
        jQuery.ajax({
            type: "get",
            dataType: "json",
            url: '/wp/wp-admin/admin-ajax.php',
            data: { action: "getFilteredPosts", formData: preparedFormData, queryArgs: self.wpQuery.queryArgs},
            beforeSend: () => {
                self.showLoading(self, 'red', '.results');

                // Disable form
                self.disableFilterFormFieldsets(self);
            },
            success: function (results) {
                // Success callback
                if (onSuccess) {
                    onSuccess(results);
                }

                // Update the query args
                if (results.queryArgs) {
                    self.updateWpQueryArgs(results.queryArgs);
                }

                self.updateFiltersState(
                    (results) => {
                        // Update filters based on current query
                        // Commenting this out because it's acting weird with little data
                        // self.disableInactiveFilters(self.taxonomyInstitutionTypes, results.activeInstitutionTypes, self);
                        self.disableInactiveFilters(self.taxonomyLevelsOfStudy, results.activeLevelsOfStudy, self);
                        self.disableInactiveFilters(self.taxonomyLearningFormats, results.activeLearningFormats, self);
                        self.disableInactiveFilters(self.taxonomyProgramLengths, results.activeProgramLengths, self);
                        self.disableInactiveFilters(self.taxonomyOnCampusLiving, results.activeOnCampusLiving, self);
                    },
                    () => {

                    },
                    self
                );

                // Hide the loading icon
                self.hideLoading(self, '.results');
            },
            error: function () {
                if (onError) {
                    onError();
                }
            }
        })
    }

    updateFiltersState(onSuccess, onError, self = this) {
        jQuery.ajax({
            type: "get",
            dataType: "json",
            url: '/wp/wp-admin/admin-ajax.php',
            data: { action: "getActiveFilters", queryArgs: self.wpQuery.queryArgs },
            beforeSend: () => {
                self.showLoading(self, 'white', `.${self.filterHeadingClass}`);
            },
            success: function (results) {
                // Success callback
                if (onSuccess) {
                    onSuccess(results);
                }

                // Hide the loading icon
                self.hideLoading(self, `.${self.filterHeadingClass}`);

                // Enable form
                self.enableFilterFormFieldsets(self);
            },
            error: function () {
                if (onError) {
                    onError();
                }
            }
        })
    }

    /**
     * Update WP Query Args
     *
     * Simple functions to update the variable value
     * of the wpQuery args to be used again in other
     * AJAX calls.
     *
     * @param {array} udpatedQueryArgs
     */
    updateWpQueryArgs(udpatedQueryArgs) {
        self.wpQuery.queryArgs = udpatedQueryArgs;
    }

    /**
     * Prepare Form Data
     *
     * Looping throught the serialized form data
     * and grouping the multiple checkboxes into a single
     * array.
     * 
     * @param {array} formDataArray The serialized form data as array
     */
    prepareFormData(formDataArray) {
        let preparedData = {};

        if (formDataArray.length > 0) {
            formDataArray.forEach(fieldData => {
                let fieldName = (fieldData.name).replace(/[\[\]']+/g, '');
                // For some reason jquery wont serializeArray when changing the programs dropdown.
                // Changing the name of the field to something other than programs works.
                fieldName = (fieldName == 'program') ? 'programs' : fieldName;
                const fieldValue = fieldData.value;

                if (!fieldValue) return;

                // If field name already exists in array
                if (preparedData[fieldName]) {
                    // contact the existing array value and new array value
                    preparedData[fieldName] = [...preparedData[fieldName], ...[fieldValue]];
                } else {
                // First time adding the field name value to the array
                    preparedData[fieldName] = [fieldValue];
                }

            })
        }

        return preparedData;
    }

    /**
     * On Programs Change
     *
     * When the user changes the selection of the
     * Programs, an ajax request will be made
     * to get the child terms or programs. The returned
     * programs are then populated into the Programs
     * dropdown.
     *
     * @param {obj} self The Filters object
     */
    onProgramsChange(self = this) {
        $(`.${self.programsSelectClass}`).on('change', (event) => {
            const selectedTermId = $(event.target).val();

            self.populateProgramAreaSelectClass(selectedTermId, self);
        })
    }

    /**
     * Populate Program Area Select
     *
     * Does an AJAX call to get the programs of the
     * Programs id.
     *
     * @param {int} parentId The Programs term id
     * @param {obj} self The Filters object
     */
    populateProgramAreaSelectClass(parentId, self) {
        const selectTarget = $(`.${self.programAreaSelectClass}`);

        // Clear and disable the programs field until it's done populating
        selectTarget.prop('disabled', true).find('option[value!=""]').remove();

        if (parentId) {
            self.getProgramAreaTerms(parentId, (terms) => {
                /**
                 * Inline function that is also the callback
                 * function when the AJAX is successful.
                 */
                if (terms.length > 0) {
                    terms.forEach((term, index) => {
                        // Append the options and remove the disabled
                        selectTarget.append($('<option>', {
                            value: term.slug,
                            text: term.name
                        })).prop('disabled', false);
                    })
                }
            }, self)
        }
    }

    /**
     * Get Program Terms
     *
     * Ajax request to get the program terms
     * that are associated to the Programs
     * id.
     *
     * After a successful request a callback function
     * is executed.
     *
     * @param {int}      parentId  The program select value
     * @param {callback} onSuccess The success callback function
     * @param {obj} self The Filters object
     */
    getProgramAreaTerms(parentId, onSuccess, self = this) {
        let terms;

        jQuery.ajax({
            type: "get",
            dataType: "json",
            url: '/wp/wp-admin/admin-ajax.php',
            data: { action: "getProgramAreaTerms", parentId: parentId },
            beforeSend: () => {
                self.showLoading(self, 'white', `.${self.filterHeadingClass}`);

                // Disable form
                self.disableFilterFormFieldsets(self);
            },
            success: function (response) {
                terms = response

                onSuccess(terms);

                // Remove loading icon
                self.hideLoading(self, `.${self.filterHeadingClass}`);

                // Enable form
                self.enableFilterFormFieldsets(self);
            }
        })

        return terms;
    }

    /**
     * Show loading spinner
     *
     * @param {*} self     The Filters object
     * @param {*} location The location where the loading icon appears in
     */
    showLoading(self = this, type = 'red', location = 'body') {
        $(location).append(() => {
            // Need to check if it's in `hot` or `build` mode
            const loadingRed = (loadingSVG.includes('localhost')) ? loadingSVG : `${self.wpEmerge.dist}/${loadingSVG}`;
            const loadingWhite = (loadingWhiteSVG.includes('localhost')) ? loadingWhiteSVG : `${self.wpEmerge.dist}/${loadingWhiteSVG}`;
            const imageUrl = (type == 'red') ? loadingRed : loadingWhite;

            return $(`<div class="${self.loadingScreenClass}"><img src="${imageUrl}" alt="Loading" /></div>`).css({ 'opacity': 0 }).fadeTo(50, 1)
        });
    }

    /**
     * Hide loading spinner
     *
     * Hides the loading icon after a certain
     * amount of time and then deletes it from the DOM.
     *
     * @param {obj} self The Filters object
     */
    hideLoading(self = this, parent = null) {
        $(`${parent} .${self.loadingScreenClass}`).fadeTo(100, 0, () => {
            setTimeout(
                () => {
                    $(`${parent} .${self.loadingScreenClass}`).remove()
                },
                150
            )
        });
    }

    /**
     * Disable Filter Form Fieldsets
     *
     * @param {obj} self The Filters class object
     */
    disableFilterFormFieldsets(self = this) {
        $(`.${self.filterFormClass} fieldset`).prop('disabled', true);
    }

    /**
     * Enable Filter Form Fieldsets
     *
     * @param {obj} self The Filters class object
     */
    enableFilterFormFieldsets(self = this) {
        $(`.${self.filterFormClass} fieldset`).prop('disabled', false);
    }
}

export default Filters;
